module.exports = __webpack_public_path__ + "static/img/light.ba22def3.svg";